import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'img:not([loading])',
})
export class LazyLoadDirective {
  nativeElement = inject<ElementRef<HTMLImageElement>>(ElementRef).nativeElement;

  constructor() {
    if (!('loading' in HTMLImageElement.prototype)) return;

    this.nativeElement.setAttribute('loading', 'lazy');
  }
}
